export const abi = [
	{
		inputs: [
			{
				components: [
					{
						internalType: 'string',
						name: '_questionId',
						type: 'string'
					},
					{
						internalType: 'string[]',
						name: '_answerIds',
						type: 'string[]'
					},
					{
						internalType: 'uint256',
						name: '_startDate',
						type: 'uint256'
					},
					{
						internalType: 'uint256',
						name: '_endDate',
						type: 'uint256'
					},
					{
						internalType: 'uint256',
						name: '_votingCap',
						type: 'uint256'
					},
					{
						internalType: 'address',
						name: 'token',
						type: 'address'
					},
					{
						internalType: 'address',
						name: 'delegate',
						type: 'address'
					},
					{
						internalType: 'bool',
						name: '_whitelistEnabled',
						type: 'bool'
					},
					{
						internalType: 'address',
						name: 'stakingAddress',
						type: 'address'
					},
					{
						internalType: 'string',
						name: 'metadataURL',
						type: 'string'
					}
				],
				internalType: 'struct ISurvey4Types.SurveyParams',
				name: 'args',
				type: 'tuple'
			}
		],
		stateMutability: 'nonpayable',
		type: 'constructor'
	},
	{
		inputs: [],
		name: 'AccessControlBadConfirmation',
		type: 'error'
	},
	{
		inputs: [
			{
				internalType: 'address',
				name: 'account',
				type: 'address'
			},
			{
				internalType: 'bytes32',
				name: 'neededRole',
				type: 'bytes32'
			}
		],
		name: 'AccessControlUnauthorizedAccount',
		type: 'error'
	},
	{
		inputs: [
			{
				internalType: 'string',
				name: 'id',
				type: 'string'
			}
		],
		name: 'addAnswerId',
		outputs: [],
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: 'string',
				name: 'id',
				type: 'string'
			}
		],
		name: 'AnswerAdded',
		type: 'event'
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: 'string',
				name: 'id',
				type: 'string'
			}
		],
		name: 'AnswerDeleted',
		type: 'event'
	},
	{
		anonymous: false,
		inputs: [],
		name: 'AnswersUpdated',
		type: 'event'
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: 'address',
				name: 'voter',
				type: 'address'
			},
			{
				indexed: true,
				internalType: 'address',
				name: 'delegate',
				type: 'address'
			},
			{
				indexed: false,
				internalType: 'bool',
				name: 'allow',
				type: 'bool'
			}
		],
		name: 'Approval',
		type: 'event'
	},
	{
		inputs: [
			{
				internalType: 'address',
				name: 'delegate',
				type: 'address'
			},
			{
				internalType: 'bool',
				name: 'allow',
				type: 'bool'
			}
		],
		name: 'approve',
		outputs: [],
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		inputs: [
			{
				internalType: 'string',
				name: 'id',
				type: 'string'
			}
		],
		name: 'deleteAnswerId',
		outputs: [],
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: 'uint256',
				name: 'newDate',
				type: 'uint256'
			}
		],
		name: 'EndDateUpdated',
		type: 'event'
	},
	{
		inputs: [
			{
				internalType: 'bytes32',
				name: 'role',
				type: 'bytes32'
			},
			{
				internalType: 'address',
				name: 'account',
				type: 'address'
			}
		],
		name: 'grantRole',
		outputs: [],
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: 'string',
				name: 'newURL',
				type: 'string'
			}
		],
		name: 'MetadataURLUpdated',
		type: 'event'
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: 'address',
				name: 'newOwner',
				type: 'address'
			}
		],
		name: 'OwnerUpdated',
		type: 'event'
	},
	{
		inputs: [
			{
				internalType: 'bytes32',
				name: 'role',
				type: 'bytes32'
			},
			{
				internalType: 'address',
				name: 'callerConfirmation',
				type: 'address'
			}
		],
		name: 'renounceRole',
		outputs: [],
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		inputs: [
			{
				internalType: 'bytes32',
				name: 'role',
				type: 'bytes32'
			},
			{
				internalType: 'address',
				name: 'account',
				type: 'address'
			}
		],
		name: 'revokeRole',
		outputs: [],
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: 'bytes32',
				name: 'role',
				type: 'bytes32'
			},
			{
				indexed: true,
				internalType: 'bytes32',
				name: 'previousAdminRole',
				type: 'bytes32'
			},
			{
				indexed: true,
				internalType: 'bytes32',
				name: 'newAdminRole',
				type: 'bytes32'
			}
		],
		name: 'RoleAdminChanged',
		type: 'event'
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: 'bytes32',
				name: 'role',
				type: 'bytes32'
			},
			{
				indexed: true,
				internalType: 'address',
				name: 'account',
				type: 'address'
			},
			{
				indexed: true,
				internalType: 'address',
				name: 'sender',
				type: 'address'
			}
		],
		name: 'RoleGranted',
		type: 'event'
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: true,
				internalType: 'bytes32',
				name: 'role',
				type: 'bytes32'
			},
			{
				indexed: true,
				internalType: 'address',
				name: 'account',
				type: 'address'
			},
			{
				indexed: true,
				internalType: 'address',
				name: 'sender',
				type: 'address'
			}
		],
		name: 'RoleRevoked',
		type: 'event'
	},
	{
		inputs: [
			{
				internalType: 'string[]',
				name: 'ids',
				type: 'string[]'
			}
		],
		name: 'setAnswerIds',
		outputs: [],
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		inputs: [
			{
				internalType: 'uint256',
				name: 'date',
				type: 'uint256'
			}
		],
		name: 'setEndDate',
		outputs: [],
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		inputs: [
			{
				internalType: 'string',
				name: 'url',
				type: 'string'
			}
		],
		name: 'setMetadataURL',
		outputs: [],
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		inputs: [
			{
				internalType: 'address',
				name: 'newOwner',
				type: 'address'
			}
		],
		name: 'setOwner',
		outputs: [],
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		inputs: [
			{
				internalType: 'address',
				name: 'newStaking',
				type: 'address'
			}
		],
		name: 'setStaking',
		outputs: [],
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		inputs: [
			{
				internalType: 'uint256',
				name: 'date',
				type: 'uint256'
			}
		],
		name: 'setStartDate',
		outputs: [],
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		inputs: [
			{
				internalType: 'address',
				name: 'newToken',
				type: 'address'
			}
		],
		name: 'setToken',
		outputs: [],
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		inputs: [
			{
				internalType: 'uint256',
				name: '_totalVotes',
				type: 'uint256'
			}
		],
		name: 'setTotalVoters',
		outputs: [],
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		inputs: [
			{
				internalType: 'uint256',
				name: 'cap',
				type: 'uint256'
			}
		],
		name: 'setVotingCap',
		outputs: [],
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		inputs: [
			{
				internalType: 'bool',
				name: '_whitelistEnabled',
				type: 'bool'
			}
		],
		name: 'setWhitelistEnabled',
		outputs: [],
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: 'address',
				name: 'newStaking',
				type: 'address'
			}
		],
		name: 'StakingUpdated',
		type: 'event'
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: 'uint256',
				name: 'newDate',
				type: 'uint256'
			}
		],
		name: 'StartDateUpdated',
		type: 'event'
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: 'address',
				name: 'newToken',
				type: 'address'
			}
		],
		name: 'TokenUpdated',
		type: 'event'
	},
	{
		inputs: [
			{
				internalType: 'string',
				name: 'id',
				type: 'string'
			},
			{
				internalType: 'uint256',
				name: 'weight',
				type: 'uint256'
			},
			{
				internalType: 'address',
				name: 'voter',
				type: 'address'
			}
		],
		name: 'vote',
		outputs: [],
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		inputs: [
			{
				internalType: 'string',
				name: 'id',
				type: 'string'
			},
			{
				internalType: 'uint256',
				name: 'weight',
				type: 'uint256'
			}
		],
		name: 'vote',
		outputs: [],
		stateMutability: 'nonpayable',
		type: 'function'
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: 'address',
				name: 'from',
				type: 'address'
			},
			{
				indexed: false,
				internalType: 'address',
				name: 'to',
				type: 'address'
			},
			{
				indexed: false,
				internalType: 'string',
				name: 'proposition',
				type: 'string'
			},
			{
				indexed: false,
				internalType: 'uint256',
				name: 'weight',
				type: 'uint256'
			}
		],
		name: 'Vote',
		type: 'event'
	},
	{
		anonymous: false,
		inputs: [
			{
				indexed: false,
				internalType: 'uint256',
				name: 'newCap',
				type: 'uint256'
			}
		],
		name: 'VotingCapUpdated',
		type: 'event'
	},
	{
		inputs: [
			{
				internalType: 'address',
				name: 'voter',
				type: 'address'
			},
			{
				internalType: 'address',
				name: 'delegate',
				type: 'address'
			}
		],
		name: 'allowance',
		outputs: [
			{
				internalType: 'bool',
				name: '',
				type: 'bool'
			}
		],
		stateMutability: 'view',
		type: 'function'
	},
	{
		inputs: [
			{
				internalType: 'uint256',
				name: '',
				type: 'uint256'
			}
		],
		name: 'answerIds',
		outputs: [
			{
				internalType: 'string',
				name: '',
				type: 'string'
			}
		],
		stateMutability: 'view',
		type: 'function'
	},
	{
		inputs: [],
		name: 'DEFAULT_ADMIN_ROLE',
		outputs: [
			{
				internalType: 'bytes32',
				name: '',
				type: 'bytes32'
			}
		],
		stateMutability: 'view',
		type: 'function'
	},
	{
		inputs: [],
		name: 'endDate',
		outputs: [
			{
				internalType: 'uint256',
				name: '',
				type: 'uint256'
			}
		],
		stateMutability: 'view',
		type: 'function'
	},
	{
		inputs: [
			{
				internalType: 'string',
				name: 'id',
				type: 'string'
			}
		],
		name: 'getAnswer',
		outputs: [
			{
				components: [
					{
						internalType: 'string',
						name: 'id',
						type: 'string'
					},
					{
						internalType: 'uint256',
						name: 'totalVotes',
						type: 'uint256'
					},
					{
						internalType: 'uint256',
						name: 'totalTokens',
						type: 'uint256'
					}
				],
				internalType: 'struct ISurvey4Types.Proposition',
				name: '',
				type: 'tuple'
			}
		],
		stateMutability: 'view',
		type: 'function'
	},
	{
		inputs: [],
		name: 'getAnswers',
		outputs: [
			{
				components: [
					{
						internalType: 'string',
						name: 'id',
						type: 'string'
					},
					{
						internalType: 'uint256',
						name: 'totalVotes',
						type: 'uint256'
					},
					{
						internalType: 'uint256',
						name: 'totalTokens',
						type: 'uint256'
					}
				],
				internalType: 'struct ISurvey4Types.Proposition[]',
				name: '',
				type: 'tuple[]'
			}
		],
		stateMutability: 'view',
		type: 'function'
	},
	{
		inputs: [],
		name: 'getQuorum',
		outputs: [
			{
				internalType: 'uint256',
				name: '',
				type: 'uint256'
			}
		],
		stateMutability: 'view',
		type: 'function'
	},
	{
		inputs: [
			{
				internalType: 'bytes32',
				name: 'role',
				type: 'bytes32'
			}
		],
		name: 'getRoleAdmin',
		outputs: [
			{
				internalType: 'bytes32',
				name: '',
				type: 'bytes32'
			}
		],
		stateMutability: 'view',
		type: 'function'
	},
	{
		inputs: [
			{
				internalType: 'address',
				name: 'user',
				type: 'address'
			}
		],
		name: 'getUserAnswers',
		outputs: [
			{
				internalType: 'bytes32[]',
				name: '',
				type: 'bytes32[]'
			}
		],
		stateMutability: 'view',
		type: 'function'
	},
	{
		inputs: [
			{
				internalType: 'address',
				name: 'user',
				type: 'address'
			},
			{
				internalType: 'bytes32',
				name: 'answer',
				type: 'bytes32'
			}
		],
		name: 'getUserVoteByAnswer',
		outputs: [
			{
				internalType: 'uint256',
				name: 'index',
				type: 'uint256'
			},
			{
				internalType: 'uint256',
				name: 'weight',
				type: 'uint256'
			},
			{
				internalType: 'uint256',
				name: 'blockNumber',
				type: 'uint256'
			}
		],
		stateMutability: 'view',
		type: 'function'
	},
	{
		inputs: [
			{
				internalType: 'bytes32',
				name: 'role',
				type: 'bytes32'
			},
			{
				internalType: 'address',
				name: 'account',
				type: 'address'
			}
		],
		name: 'hasRole',
		outputs: [
			{
				internalType: 'bool',
				name: '',
				type: 'bool'
			}
		],
		stateMutability: 'view',
		type: 'function'
	},
	{
		inputs: [],
		name: 'isOpen',
		outputs: [
			{
				internalType: 'bool',
				name: '',
				type: 'bool'
			}
		],
		stateMutability: 'view',
		type: 'function'
	},
	{
		inputs: [],
		name: 'metadataURL',
		outputs: [
			{
				internalType: 'string',
				name: '',
				type: 'string'
			}
		],
		stateMutability: 'view',
		type: 'function'
	},
	{
		inputs: [],
		name: 'questionId',
		outputs: [
			{
				internalType: 'string',
				name: '',
				type: 'string'
			}
		],
		stateMutability: 'view',
		type: 'function'
	},
	{
		inputs: [],
		name: 'startDate',
		outputs: [
			{
				internalType: 'uint256',
				name: '',
				type: 'uint256'
			}
		],
		stateMutability: 'view',
		type: 'function'
	},
	{
		inputs: [
			{
				internalType: 'bytes4',
				name: 'interfaceId',
				type: 'bytes4'
			}
		],
		name: 'supportsInterface',
		outputs: [
			{
				internalType: 'bool',
				name: '',
				type: 'bool'
			}
		],
		stateMutability: 'view',
		type: 'function'
	},
	{
		inputs: [],
		name: 'token',
		outputs: [
			{
				internalType: 'address',
				name: '',
				type: 'address'
			}
		],
		stateMutability: 'view',
		type: 'function'
	},
	{
		inputs: [],
		name: 'totalTokensUsed',
		outputs: [
			{
				internalType: 'uint256',
				name: '',
				type: 'uint256'
			}
		],
		stateMutability: 'view',
		type: 'function'
	},
	{
		inputs: [],
		name: 'totalVotes',
		outputs: [
			{
				internalType: 'uint256',
				name: '',
				type: 'uint256'
			}
		],
		stateMutability: 'view',
		type: 'function'
	},
	{
		inputs: [],
		name: 'votingCap',
		outputs: [
			{
				internalType: 'uint256',
				name: '',
				type: 'uint256'
			}
		],
		stateMutability: 'view',
		type: 'function'
	},
	{
		inputs: [],
		name: 'WHITELIST_ADMIN_ROLE',
		outputs: [
			{
				internalType: 'bytes32',
				name: '',
				type: 'bytes32'
			}
		],
		stateMutability: 'view',
		type: 'function'
	},
	{
		inputs: [],
		name: 'WHITELISTED_ROLE',
		outputs: [
			{
				internalType: 'bytes32',
				name: '',
				type: 'bytes32'
			}
		],
		stateMutability: 'view',
		type: 'function'
	},
	{
		inputs: [],
		name: 'whitelistEnabled',
		outputs: [
			{
				internalType: 'bool',
				name: '',
				type: 'bool'
			}
		],
		stateMutability: 'view',
		type: 'function'
	}
] as const
